import React, { FunctionComponent } from 'react';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';
// import { AnimatePresence } from 'framer-motion';

import TourView from './previews/tour';
import LinksView from './previews/links';
import GeneralView from './previews/general';

import Button from '@components/actions/button';

interface SitePreviewProps {
  className?: string;
  previewShowing: 'general' | 'links' | 'tour';
  btnText: string;
  isDisabled?: boolean;
  hideBtn?: boolean;
  onSaveChanges: () => void;
}

const SitePreview: FunctionComponent<SitePreviewProps> = ({
  className,
  previewShowing,
  btnText,
  isDisabled,
  hideBtn,
  onSaveChanges,
}) => {
  const getPreview = (previewShowing: 'general' | 'links' | 'tour') => {
    if (previewShowing === 'tour') {
      return <TourView />;
    } else if (previewShowing === 'links') {
      return <LinksView />;
    }
    return <GeneralView />;
  };

  return (
    <div className={className || ''}>
      <div className="preview">{getPreview(previewShowing)}</div>
      {!hideBtn ? (
        <Button
          buttonType="primary"
          small
          fullWidth
          onClick={onSaveChanges}
          disabled={isDisabled}
        >
          <Translate id={btnText} />
        </Button>
      ) : null}
    </div>
  );
};

export default styled(SitePreview)`
  display: grid;
  grid-gap: 20px;
  margin-top: 30px;

  .preview {
    display: none;
  }

  @media ${({ theme }) => theme.device.laptopM} {
    .preview {
      display: block;
    }

    margin-top: 0;
    position: fixed;
    top: 208px;
    right: 20px;
  }
  @media ${({ theme }) => theme.device.laptopL} {
    right: 80px;
  }

  .loading-animation {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    opacity: 0;
    transition: opacity
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

    &.is-loading {
      opacity: 1;
    }

    svg {
      path {
        fill: ${({ theme }) => theme.colors.primary};
      }
    }
  }
`;
